import { selectionBatterPositionKeys } from "./publicKeys";


export default function getAvailablePositions(position) {
    if (['SP1', 'SP2', 'SP3', 'SP4', 'SP5'].includes(position)) {
        return ['SP'];
    } else if (['RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6'].includes(position)) {
        return ['RP'];
    } else if (['SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6'].includes(position)) {
        return selectionBatterPositionKeys;
    } else if (position === 'DH') {
        return selectionBatterPositionKeys;
    } else {
        return [position];
    }
}